import { adminFetch } from "./_client";
import type { LegalContent, LegalPageMeta, LegalRevisionSummary, LegalRevisionDetail } from "./types";


export function fetchLegalPagesList(token: string) {
  return adminFetch<{ pages: LegalPageMeta[] }>(`/admin/legal-pages`, token);
}

export function fetchLegalPageDetail(token: string, pageKey: string, locale = "en") {
  return adminFetch<{ page: (LegalPageMeta & { content: LegalContent }) | null; revisions: LegalRevisionSummary[] }>(
    `/admin/legal-pages/${encodeURIComponent(pageKey)}?locale=${encodeURIComponent(locale)}`, token,
  );
}

export function saveLegalPage(token: string, pageKey: string, body: { locale?: string; content: LegalContent; change_note?: string; requires_reconsent?: boolean }) {
  return adminFetch<{ ok: boolean; revision_id: number; updated_at: string }>(
    `/admin/legal-pages/${encodeURIComponent(pageKey)}`, token,
    { method: "PUT", body: JSON.stringify(body) },
  );
}

export function fetchLegalRevision(token: string, pageKey: string, revId: number) {
  return adminFetch<{ revision: LegalRevisionDetail }>(
    `/admin/legal-pages/${encodeURIComponent(pageKey)}/revisions/${revId}`, token,
  );
}

export function restoreLegalRevision(token: string, pageKey: string, revId: number) {
  return adminFetch<{ ok: boolean; revision_id: number }>(
    `/admin/legal-pages/${encodeURIComponent(pageKey)}/revisions/${revId}/restore`, token,
    { method: "POST" },
  );
}
